import { Component, ojs, app, payload } from "modular-openscriptjs";
import {
	pageInfo,
	either,
	formatThousand,
	tab
} from "../../../helpers";
import { dom } from "../../../fotastart";
import { dc, gc, PAGES, pc } from "../../../declarations";
import { routes } from "../../../backendRoutes";
import { $e } from "../../../ojs.events";


const h = app("h");
const api = app("api");
const broker = app("broker");
const route = app("router");

export default class Followers extends Component {
	render(userState, ...args) {
		let user = userState?.value;

		if (!user?.id) {
			return h.Loader("dots");
		}

		if (route.is("user.view-followers")) {
			pageInfo(PAGES.FOLLOWERS);
			pc.pageTitle.value = user?.display_name;
		}

		return h.div(
			{ class: "py-md-5" },
			h.Tabs({
				holders: {
					nav: h.div({
						class: "nav nav-tabs nav-fill mb-3",
					}),
					body: h.div({ class: "tab-content" }),
				},
				tabs: [
					tab(
						h.button(
							{ class: "nav-link active fs-sm" },
							"Followers",
							h.span(
								{ class: "badge text-primary rounded-circle" },
								formatThousand(user?.follower_count)
							)
						),
						h.div(
							{ class: "tab-pane fade show active" },
							h.InfiniteScroll({
								child: h.FollowersList({
									id: "ff-followers-list",
								}),
								callback: (entries, observer, marker) => {
									entries.forEach((entry) => {
										if (!entry.isIntersecting) return;
										this.populateFollows(
											"ff-followers-list",
											marker,
											"/followers",
											dc.followersPage
										);
									});
								},
							})
						)
					),
					tab(
						h.button(
							{ class: "nav-link fs-sm" },
							"Followings",
							h.span(
								{ class: "badge text-primary rounded-circle" },
								formatThousand(user?.following_count)
							)
						),
						h.div(
							{ class: "tab-pane fade" },
							h.InfiniteScroll({
								child: h.FollowersList({
									id: "ff-followings-list",
								}),
								callback: (entries, observer, marker) => {
									entries.forEach((entry) => {
										if (!entry.isIntersecting) return;
										this.populateFollows(
											"ff-followings-list",
											marker,
											"/followings",
											dc.followingsPage
										);
									});
								},
							})
						)
					),
					h.call(() => {
						return either(
							gc.user?.id == user?.id,
							() => [
								tab(
									h.button(
										{ class: "nav-link fs-sm text-danger" },
										h.i({ class: "fas fa-ban" })
									),
									h.div(
										{ class: "tab-pane fade" },
										h.InfiniteScroll({
											child: h.FollowersList({
												id: "ff-followers-blocked-list",
											}),
											callback: (
												entries,
												observer,
												marker
											) => {
												entries.forEach((entry) => {
													if (!entry.isIntersecting)
														return;
													this.populateFollows(
														"ff-followers-blocked-list",
														marker,
														"/followers/blocked",
														dc.bannedPage
													);
												});
											},
										})
									)
								),
							],
							[]
						);
					}),
				],
			}),
			h.Fab([
				h.ScanQRFab(),
				h.button(
					{
						class: "btn bg-white",
						type: "button",
						data_bs_toggle: "offcanvas",
						data_bs_target:
							"[c-followers-su-canvas='followers-su-canvas']",
					},
					h.i({ class: "fa-solid fa-users" })
				),
			]),
			h.SuggestedUsersCanvas({
				c_followers_su_canvas: "followers-su-canvas",
			}),
			...args
		);
	}

	async populateFollows(holderId, marker, path, map) {
		map.next++;
		let page = map.next;
		let id =
			route.params.user == "current" ? gc.user?.id : route.params.user;

		path = `${id}/${path}`;

		let spinner = h.Spinner({ parent: marker, resetParent: true });

		let res = await api.get(`${routes.users}/${path}`, {
			page,
			interval: 10,
		});

		if (res) {
			let follows = res.data.follows.data;

			for (let follow of follows) {
				h.FollowerProfile(follow, {
					class: "rounded bg-light border p-3 mb-3",
					parent: dom.id(holderId),
				});
			}

			if (!follows?.length) map.next = page - 1;
		}

		spinner.remove();
	}

	$$ojs = {
		routeChanged_beforeRouteChange: (ed, event) => {
			this.cleanUp();
		},
	};

	cleanUp() {
		super.cleanUp();

		dc.bannedPage = { next: 0 };
		dc.followersPage = { next: 0 };
		dc.followingsPage = { next: 0 };
	}
}

function FollowersList(...args) {
	return h.div(...args);
}

class FollowerProfile extends Component {
	render(follow, ...args) {
		let vId = route.params.user;
		if (vId == "current") vId = gc.user.id;

		let user = follow.user;
		if (user.id == vId) user = follow.follower;

		return h.div(
			{ class: "d-flex gap-3 flex-column", role: "button" },
			h.div(
				{ class: "d-flex gap-3" },
				h.div(
					{ class: "position-relative" },
					h.img(
						{
							class: "rounded-circle mx-auto d-block border mb-2",
							style: "max-width: 50px; height: auto",
							id: "user-profile-avatar",
						},

						either(
							user?.profile_photo_path,
							{
								src: user?.profile_photo_path,
								onclick: h.func(
									"broker.send",
									$e.image.needs.view,
									payload({
										sources: [user?.profile_photo_path],
									})
								),
							},
							{ src: "/assets/images/user-avatar.png" }
						)
					),
					either(
						user?.is_business,
						() =>
							h.span(
								{
									class: "position-absolute fixed-bottom text-info",
									style: `
                                bottom: 0px;
                                left: 30px;
                            `,
								},
								h.i({
									class: "fas fa-shop",
									style: "font-size: 1.25em;",
								})
							),
						either(user?.is_verified, () =>
							h.span(
								{
									class: "position-absolute fixed-bottom text-info",
									style: `
                        bottom: 0px;
                        left: 30px;
                    `,
								},
								h.i({
									class: "fas fa-circle-check",
									style: "font-size: 1.5em;",
								})
							)
						)
					)
				),
				h.div(
					{
						class: "d-flex flex-column flex-fill",
					},
					h.span(
						{
							class: "fw-bold ",
						},
						user?.display_name,
						either(
							follow?.is_blocked == 0,

							{
								onclick: h.func(
									"route.to",
									"user.view-profile",
									{
										user:
											user?.id == gc.user?.id
												? "current"
												: user?.id,
									}
								),
							}
						)
					),
					h.span(
						{
							class: "text-secondary",
						},
						either(
							follow?.is_blocked == 0,

							{
								onclick: h.func(
									"route.to",
									"user.view-profile",
									{
										user:
											user?.id == gc.user?.id
												? "current"
												: user?.id,
									}
								),
							}
						),
						"@",
						user?.username
					),
					h.div(
						{
							class: "d-flex gap-3",
						},
						h.call(() => {
							return either(
								follow?.is_blocked == 1,
								() =>
									h.span(
										{
											class: "text-success fw-bold",
											onclick: this.method("unblock", follow),
										},
										"Unblock"
									),
								() => [
									h.span(
										{
											class: "form-text",
											onclick: h.func(
												"route.to",
												"user.view-followers",
												{
													user:
														user?.id == gc.user?.id
															? "current"
															: user?.id,
												}
											),
										},
										formatThousand(user.follower_count),
										" Follower",
										either(user.follower_count > 1, "s")
									),
									h.span(
										{
											class: "form-text",
											onclick: h.func(
												"route.to",
												"user.view-followers",
												{
													user:
														user?.id == gc.user?.id
															? "current"
															: user?.id,
												}
											),
										},
										formatThousand(user.following_count),
										" Following",
										either(user.following_count > 1, "s")
									),
								]
							);
						})
					)
				)
			),
			...args
		);
	}

	unblock(follow) {
		broker.send($e.user.needs.toUnblock, payload({ follow }));
	}
}

ojs(Followers, FollowerProfile);
